import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import RelatorioPagamentosLayer from "../components/RelatorioPagamentosLayer";
import { useTranslation } from "../i18n/I18nContext";

const RelatorioPagamentosPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("relatorioPagamentos.breadcrumb")} />
      <RelatorioPagamentosLayer />
    </MasterLayout>
  );
};

export default RelatorioPagamentosPage;
